import { Input, Output, EventEmitter, OnChanges, SimpleChanges, Directive } from '@angular/core';

import { Vraag, Antwoord } from '@models/claims';
import { IBaseVraagboomResultaat, VraagboomAntwoord } from '@models/vragenboom';
import { BaseOlsControlDirective } from '../../base/base-ols-control';
import { RequiredValidator } from '../../../utils/validation/required.validator';
import { Observable } from 'rxjs';
import { DataService } from '@components/public_api';
import { takeUntil } from 'rxjs/operators';

@Directive()
export abstract class BaseVraagControlDirective<TResultaat extends IBaseVraagboomResultaat> extends BaseOlsControlDirective implements OnChanges {
  // TODO nagaan of je hier niet alleen het antwoord wil doorgeven. En verdere logica in vraag-control.component wilt afhandelen.
  @Input() vraag: Vraag;
  @Input() antwoordResultaat: VraagboomAntwoord<TResultaat>;
  @Output() antwoordResultaatChange: EventEmitter<VraagboomAntwoord<TResultaat>> = new EventEmitter<VraagboomAntwoord<TResultaat>>();

  submitClicked$: Observable<boolean>;
  submitClicked: boolean;

  constructor(public _dataService: DataService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => {
      // Initialize is handled within setTimeout because of ExpressionChangedAfterItHasBeenCheckedError

      if (this.antwoordResultaat != null) {
        // The initialize will trigger to update the value of the control.
        // This change will result in ExpressionChangedAfterItHasBeenCheckedError in parent control
        this.initialize(changes);

        this.submitClicked$ = this._dataService.submitClicked;
        this.submitClicked$
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(sc => { this.submitClicked = sc; });
        // Validate current answer
        this.antwoordResultaat.isValid = this.validateResultaat(this.antwoordResultaat.antwoorden, this.antwoordResultaat.resultaat);
      }
    });
  }

  abstract initialize(changes: SimpleChanges): void;

  setAntwoord(antwoorden: Antwoord[], resultaat: TResultaat): void {
    if (this.antwoordResultaat == null) {
      this.antwoordResultaat = new VraagboomAntwoord<TResultaat>();
    }

    this.antwoordResultaat.vraag = this.vraag;
    this.antwoordResultaat.antwoorden = antwoorden;
    this.antwoordResultaat.resultaat = resultaat;
    this.antwoordResultaat.isValid = this.validateResultaat(antwoorden, resultaat);
    this.antwoordResultaatChange.emit(this.antwoordResultaat);
  }

  validateResultaat(antwoorden: Antwoord[], resultaat: TResultaat): boolean {
    if (this.vraag == null) {
      return false;
    }

    const isValid = RequiredValidator.isValid(this.vraag, resultaat);
    return isValid && this.validate(this.vraag, antwoorden, resultaat);
  }

  abstract validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: TResultaat): boolean;
}
